<template lang="pug">
  #LabelIndex.container-width
    h5.text-center.py-3.letter-spacing-6 客戶標籤
    hr.border.border-primary.w-100
    .row.no-gutters.mb-3
      .col-6.button-item-first
        b-button(
          :variant="nowSelect === 'binding' ? 'primary' : 'outline-primary'",
          block,
          @click="changeStatusHandler('binding')",
          class="rounded-0 text-black"
        ) 一對一摯友客戶
      .col-6
        b-button(
          :variant="nowSelect === 'others' ? 'primary' : 'outline-primary'",
          block,
          @click="changeStatusHandler('others')",
          class="rounded-0 text-black"
        ) 預約服務客戶
    div
      p.mb-0.text-center(
        v-if="noData"
      ) 無更多資料
      b-card.border-0.mb-2.customerCard.word-break-all(
        bg-variant="light",
        v-for="(tag,index) in tags",
        :key="tag.id"
      )
        .row
          .col-10.d-flex.align-items-center
            span.mr-3 {{ tag.tag_name }}
            i.fas.fa-user.mr-1.text-danger
            span.text-danger {{ tag.use_count }}
          .col-2.d-flex.align-items-center.justify-content-end.toolsButton
            label.mb-0.d-flex.flex-row-reverse.position-relative(
              :for="`dropTools_${index}`"
              @click="toolsHandler(index)"
            )
              input.toolsInput.d-none(
                type="checkbox",
                :id="`dropTools_${index}`",
                :name="`dropTools_${index}`",
                :checked="toolsOpen.indexOf(index) !== -1"
              )
              b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.iconToolsBtn(
                variant="primary"
              )
                i.fas.fa-tools.iconTools
              b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.position-absolute.iconPushBtn(
                variant="primary",
                @click="pushHandler(tag)"
              )
                i.fas.fa-volume-up.iconPush
              b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.position-absolute.iconEditBtn(
                variant="primary",
                @click="editHandler(tag)"
              )
                i.fas.fa-pencil-alt.iconEdit
</template>

<script>
import { mapState } from 'vuex';
import defaultPhotoStickerUrl from '@/assets/images/default/defaultImg404.png';
import { SA_LABEL_EDIT } from '@/router/sa/label';
import { SA_GROUP_PUSH_INDEX } from '@/router/sa/group-push';

export default {
  name: 'LabelIndex',
  data() {
    return {
      defaultPhotoSticker: `this.src="${defaultPhotoStickerUrl}"`,
      nowSelect: 'binding',
      toolsOpen: []
    };
  },
  created() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    vm.getBackendTagsHandler();
  },
  methods: {
    // 取得標籤
    getBackendTagsHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '請稍候，\n標籤載入中',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 取得標籤
      vm.$store.dispatch('sa_label/getBackendTagsHandler', {
        filter_type: vm.nowSelect
      })
        .then(() => {
          vm.$swal.close();
        });
    },
    toolsHandler(index) {
      const vm = this;
      if (vm.toolsOpen.indexOf(index) === -1) {
        vm.toolsOpen.push(index);
      } else {
        vm.toolsOpen.splice(vm.toolsOpen.indexOf(index), 1);
      }
    },
    pushHandler(tag) {
      const vm = this;
      if (!tag.use_count || tag.use_count === 0) return;
      vm.$swal.fire({
        title: '請稍候，\n載入中',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });

      if (!vm.nowSelect) {
        vm.$swal.fire({
          icon: 'error',
          title: '推播目標錯誤\n[Err: Not Has NowSelect]'
        });
        return;
      }

      vm.$store.dispatch('sa_label/showBackendTagHandler', {
        tag_id: tag.tag_id,
        filter_type: vm.nowSelect
      })
        .then((res) => {
          vm.$swal.close();
          vm.$store.commit('sa_group_push/setMemberList', res.has_tag_members);
          vm.$router.push({
            name: SA_GROUP_PUSH_INDEX
          });
        });
    },
    editHandler({ tag_id }) {
      const vm = this;
      vm.$router.push({
        name: SA_LABEL_EDIT,
        params: {
          tag_id,
          mode: vm.nowSelect
        }
      });
    },
    deleteHandler(tag) {
      const vm = this;
      vm.$swal.fire({
        title: '您確定刪除標籤?',
        text: '刪除後標籤無法復原！',
        html: `請注意，刪除後已經貼標的客戶將失去<span style="color: #d33"> ${tag.tag_name} </span> 標籤`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary px-5'
        }
      }).then((result) => {
        if (result.value) {
          vm.$swal.fire({
            title: '請稍候，\n標籤刪除中',
            allowOutsideClick: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });

          vm.$store.dispatch('sa_label/destroyTagHandler', {
            tag_id: tag.tag_id
          })
            .then(() => {
              vm.$swal.close();
              vm.$snotify.success(null, '刪除成功');
              vm.$store.commit('sa_label/resetAll');
              vm.getBackendTagsHandler();
            });
        }
      });
    },
    changeStatusHandler(type) {
      const vm = this;
      switch (type) {
        case 'binding':
          if (vm.nowSelect === 'binding') return;
          vm.nowSelect = 'binding';
          vm.$store.commit('sa_label/resetAll');
          vm.getBackendTagsHandler();
          break;
        case 'others':
          if (vm.nowSelect === 'others') return;
          vm.nowSelect = 'others';
          vm.$store.commit('sa_label/resetAll');
          vm.getBackendTagsHandler();
          break;
        default:
          break;
      }
    }
  },
  computed: {
    ...mapState({
      tags: (state) => state.sa_label.tags,
      noData: (state) => state.sa_label.noData
    })
  }
};
</script>

<style lang="scss" scoped>
</style>
